import _defineProperty2 from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { css } from "styled-components";
import { QUERIES } from "./consts";
export var getBreakpointWidth = function getBreakpointWidth(name, theme, pure) {
  var _tokens;

  var tokens = (_tokens = {}, _defineProperty2(_tokens, QUERIES.MEDIUMMOBILE, theme.orbit.widthBreakpointMediumMobile), _defineProperty2(_tokens, QUERIES.LARGEMOBILE, theme.orbit.widthBreakpointLargeMobile), _defineProperty2(_tokens, QUERIES.TABLET, theme.orbit.widthBreakpointTablet), _defineProperty2(_tokens, QUERIES.DESKTOP, theme.orbit.widthBreakpointDesktop), _defineProperty2(_tokens, QUERIES.LARGEDESKTOP, theme.orbit.widthBreakpointLargeDesktop), _tokens);

  if (pure) {
    return tokens[name];
  }

  return "(min-width: ".concat(tokens[name], "px)");
};
var mediaQueries = Object.keys(QUERIES).reduce(function (o, name) {
  return _objectSpread({}, o, _defineProperty2({}, QUERIES[name], function (style) {
    return css(["@media ", "{", ";}"], function (_ref) {
      var theme = _ref.theme;
      return getBreakpointWidth(QUERIES[name], theme);
    }, style);
  }));
}, {});
export default mediaQueries;